@if (coreWebComponentPayload$ | async; as payload) {
  <checkout-core
    [class.hidden]="!payload.visible"
    [authToken]="payload.authToken"
    [language]="payload.language"
    [config]="payload.config">
    <div slot="stripe-payment-element" id="stripe-payment-element-id"></div>
  </checkout-core>
}